<template>
	<div class="group">
		<div class="result-index">
			<div class="wrapper">
				<div class="summary">
					<div class="box-wrapper">
						<ResultIndexLevelChart></ResultIndexLevelChart>
						<div class="box-chart">
							<LevelDoughnut v-bind:levelScorePercentageArray="levelScorePercentageArray" v-bind:levelColor="levelColor"></LevelDoughnut>
						</div><!-- end .box-chart -->
					</div><!-- end .box-wrapper -->
				</div><!-- end .summary -->
				<ResultIndexProgress></ResultIndexProgress>		
			</div><!-- end .wrapper -->
		</div><!-- end .result-index -->
		<div class="subject">
			<div  class="text">
				<h3>- この結果を有効活用しよう -</h3>
				<h2 >自分の置かれた状況や環境を<br>
				内向性の観点から捉えるだけで<br>
				成功の確率は大きく変わる</h2>
				<p class="en">Epilogue of this diagnosis</p>
			</div><!-- end .text -->

		</div><!-- end .subject -->
		<div class="contents">
			<div class="sentence">
				<img src="../assets/result-detail-last-message01.svg" alt="*" class="visual" />
				<div class="caption">
					人間のあらゆる活動は、自分で内向したものを外へ放つことで価値を生む
				</div><!-- end .caption -->
				<p>私たちは、時代が進むにつれて、優れたシステム、ツール、情報を手に入れることができるようになっていきます。これは今の時代が優れたインプットのチャンスに溢れていることを意味します。インプットは、自分との内向的な時間そのものです。</p>
				
				<p>だからこそ、自分の内向性(もしくは外向性)の質に合わせて行動することで、アウトプットの価値を大きく変えることができます。それは最終的に、あなたの市場価値、給料、人気、需要、スキルアップすべてに繋がります。自分の人生を自分の好きなように変革できるかどうかは、自分の内向性と外向性をどう生かすかに大きくかかっているのです。</p>

				<h2>強みを尖らせて個性に変え、致命的な弱点を柔らかくすれば、あなたは自分らしく人生を過ごせる</h2>
				<img src="../assets/result-detail-last-message02.svg" alt="*" class="visual" />
				<div class="caption">
					内向型であろうが、外向型であろうが、弱点を少しずつケアしながら、強みにコミットすることはとても重要な戦略だ
				</div><!-- end .caption -->
				<p>時は金なりと言いますが、時間は1日24時間、すべての人に平等に与えられています。どんな人でもすべての能力やスキルは体得できませんし、すべてを強みにすることはできず、すべての弱点を克服することも無理なのです。要は大事なのはチョイスです。</p>
				<p>1つのことを極めた人も、どんなにマルチな活躍を実現させた人でも、その人には手にれらていない強みがあり、克服できていない弱点があります。要は、自分に即した強みと弱みに向き合うことをチョイスできたらこそ、彼らは次第に、歳を重ねることに自分らしく、ありのままに幸福や成功を重ねていけるのです。</p>
				<h2>さぁ、今からあらゆる世界を、内向性・外向性というフィルターで覗いてみよう</h2>
				<img src="../assets/result-detail-last-message03.svg" alt="*" class="visual" />
				<div class="caption">
					物事や人間心理を読み取ろうとするときに、内向性と外向性の視点を持ってみる
				</div><!-- end .caption -->
				<p>内向性、外向性というフィルターを通して、自分を診断し、見つめ直すだけでも、様々な本質的なことが浮き彫りになったことが理解できましたよね。</p>
				<p>自分だけでなく、他人や社会の本質を知ることにも、同様です。内向性、外向性というフィルターを通すだけで、他人の隠れた本音を理解することができたり、自分の仕事で力を発揮する重要な手掛かりに気づけるようになったりします。</p>

				<p>まさに、私たちが今回のような長尺の内向型診断を作った理由がそこにあります。</p>

				<ul class="check">
					<li>
						<div class="text">
							「あの人は内向的か？」
						</div><!-- end .text -->
					</li>
					<li>
						<div class="text">
						「このチームのトップは外向的か？」
						</div><!-- end .text -->
					</li>
					<li>
						<div class="text">
						「このジャンルで成功するには、内向的な人に向いているのか？」
						</div><!-- end .text -->
					</li>
					<li>
						<div class="text">
						「あそこで活躍するには、スキルよりも外向性を打ち出すべきではないのか？」
						</div><!-- end .text -->
					</li>
				</ul>
				<p>置かれた環境を、ぜひ、内向性・外向性というフィルターからのぞいてみて下さい。すると、あなたの人生はもっとシンプルに、うまくいく、私たちはそう信じています。</p>
			</div><!-- end .sentence -->
		</div><!-- end .contents -->
		<div class="subject last">
			<div  class="text">
				<h3 >- またの定期後診断を -</h3>
				<h2 >あなたの内向度や外向性は<br>
				経験を重ねるにつれて<br>
				大きく変動する</h2>
				<p class="en">Epilogue of this diagnosis</p>
			</div><!-- end .text -->
		</div><!-- end .subject -->
		<div class="contents">
			<div class="sentence">
				<p>あなたの持つ内向性と外向性の特徴は、これからの経験やスキルアップでこれから大きく変わります。また、あなたがどんな目標を持つのか、どんなコミュティに属しているのかによって、必要となる内向性の質や外向性の度合いもまったく変わってくるでしょう。その都度、自分に求められる内向性と外向性をパフォーマンスしていかなければなりません。</p>
				<p>ぜひ、今回の診断だけでなく、新たな目標や成長がある度に、この診断を受けてみて頂ければと思います。また、あなたが再来訪するときは、今とは違うアップデートが施されているかもしれません。
				</p>
				<p>無料ですので、友人や会社の同僚に診断をシェアしてみるのも良いでしょう。周りの人と診断結果をシェアすることで、よりあなたは内向性と外向性を理解するセンスが磨かれていくはずです。</p>
				<p>それでは、診断お疲れ様でした。診断を通じて出会ったあなたのこれからの人生がまずまず上昇することを心より願っております。</p>
			</div><!-- end .sentence -->
		</div><!-- end .contents -->
	</div><!-- end .group -->
			
</template>
		

<script>

import LevelDoughnut from '../components/LevelDoughnut.vue'
import ResultIndexLevelChart from '../components/ResultIndexLevelChart.vue'
import ResultIndexProgress from '../components/ResultIndexProgress.vue'


export default {
	name: 'ResultDetailLastMessage',
	components: {
		LevelDoughnut,
		ResultIndexLevelChart,
		ResultIndexProgress,

	},
	
	data: function () {
		return {
			bgWidth:100,
			levelTitle:'内向度',
			levelColor:['#359799','#a6b9b9'],
		}
	},
	props:[

	],
	computed: {
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		levelScorePercentageArray:function(){
			let levelScorePercentageArray =[Number(this.levelResult.percentage) ,Number(100-this.levelResult.percentage)];
			return levelScorePercentageArray;
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
